var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"min-height mx-auto max-w-2xl"},[_c('keep-alive',{attrs:{"include":_vm.$store.getters.keepAlives}},[_c('router-view')],1)],1),(_vm.$route.meta.hasFooter)?_c('Footer'):_vm._e(),(_vm.$route.meta.hasTabbar)?[(!_vm.isMiniapp)?_c('Tabbar'):_c('MiniTabbar')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }